import { FC } from "preact/compat";
import OutlookIcon from "~/assets/outlook.svg";

const Preview: FC = () => (
    <div className="flex size-full items-center justify-center">
        <OutlookIcon width="60" height="60" />
    </div>
);

export default Preview;
